import { render, staticRenderFns } from "./CardAttach.vue?vue&type=template&id=9ce224a0&scoped=true&"
import script from "./CardAttach.vue?vue&type=script&lang=js&"
export * from "./CardAttach.vue?vue&type=script&lang=js&"
import style0 from "./CardAttach.vue?vue&type=style&index=0&id=9ce224a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce224a0",
  null
  
)

export default component.exports